/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

export type CarouselUmbBlockElementModelContentType =
	(typeof CarouselUmbBlockElementModelContentType)[keyof typeof CarouselUmbBlockElementModelContentType];

export const CarouselUmbBlockElementModelContentType = {
	carouselUmbBlock: "carouselUmbBlock",
} as const;
